export default "__VITE_ASSET__VWrXm3mf__"